import React, { Fragment } from "react";
import { string, func, object, bool } from "prop-types";

export const CompleteCheck = () => (
  <div
    style={{
      display: "flex",
      backgroundColor: "green",
      width: "40px",
      height: "40px",
      borderRadius: "20px",
      color: "white",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      right: "10px",
      bottom: "15px",
    }}
  >
    <i className="icomoon-checkmark" style={{ fontSize: "23px" }} />
  </div>
);

const InputFile = ({
  styles = {},
  containerStyle = {},
  classes,
  onChangeHandler,
  idName,
  text = "Find file",
  acceptMimeTypes = "application/rtf,text/rtf,text/richtext,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  hasFileSelected = false,
  previewImage,
  disabled = false,
  noMarginLeft = false,
  name = null,
}) => {
  return (
    <div
      style={
        noMarginLeft ? { ...containerStyle, marginLeft: "0" } : containerStyle
      }
    >
      <div style={{ position: "relative" }}>
        {hasFileSelected && (
          <Fragment>
            <div id={`${idName}-preview`} className="mb-1">
              <img
                src={`data:image/jpeg;base64,${previewImage}`}
                style={{ maxWidth: "100%" }}
              />
            </div>
            <CompleteCheck />
          </Fragment>
        )}
      </div>
      <label htmlFor={idName} className={classes} style={styles}>
        {text}
      </label>
      <input
        type="file"
        name={`${name || "file"}`}
        accept={acceptMimeTypes}
        onChange={(e) => onChangeHandler(e)}
        className="d-none"
        id={idName}
        disabled={disabled}
      />
    </div>
  );
};

InputFile.propTypes = {
  idName: string.isRequired,
  name: string,
  text: string,
  containerStyle: object,
  onChangeHandler: func.isRequired,
  acceptMimeTypes: string,
  styles: object,
  classes: string,
  previewImage: string,
  hasFileSelected: bool,
  disabled: bool,
  noMarginLeft: bool,
};

export default InputFile;
